const Game = {
	isFinished: () => sessionStorage.getItem("game-finished") == "true",
	end: () => {
		sessionStorage.setItem("game-finished", true)
	},
}

export default Game
